const LOCK_WINDOW_MS = 5000;

const getLockKey = (user) =>
  `order_lock_${user?.id || user?._id || "guest"}`;

export const useOrderLock = (user) => {
  const acquire = () => {
    const key = getLockKey(user);
    const existing = localStorage.getItem(key);

    if (existing) {
      const lockTime = parseInt(existing, 10);
      const now = Date.now();
      if (now - lockTime < LOCK_WINDOW_MS) {
        throw new Error("Please wait before placing another order");
      }
    }

    localStorage.setItem(key, Date.now().toString());
  };

  const release = () => {
    localStorage.removeItem(getLockKey(user));
  };

  return { acquire, release };
};
